import React from "react";
import { Chart as ChartJS, Tooltip, Legend, Filler } from "chart.js/auto";
import { Line } from "react-chartjs-2";
import { CommonUtilities } from "../../commonUtils";

ChartJS.register(Tooltip, Legend, Filler);

export default function AreaChart(chartPassedData: any) {
  const options = {
    ...chartPassedData?.chartPassedData?.options,
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: "index" as const,
    },
    layout: {
      padding: { top: 0 },
    },
    plugins: {
      ...chartPassedData?.chartPassedData?.options?.plugins,
      tooltip: {
        ...chartPassedData?.chartPassedData?.options?.plugins?.tooltip,
        enabled: true,
        backgroundColor: "white",
        titleColor: "black",
        bodyColor: "black",
        borderColor: "black",
        borderWidth: 1,
        cornerRadius: 4, 
      },
    },
    elements: {
      line: {
        tension: 0.4,
      },
    },
    scales: chartPassedData?.chartPassedData?.options?.scales,
  };

  const data = {
    ...chartPassedData?.chartPassedData?.data,
    datasets:
      chartPassedData?.chartPassedData?.data?.datasets?.map((dataset: any) => ({
        ...dataset, 
      })) ?? [],
  };

  return (
    <>
      {chartPassedData?.chartPassedData?.data?.labels?.length > 0 && (
        <div
          style={{
            ...CommonUtilities.parseStyleString(chartPassedData?.style),
            height: "450px",
            width: "100%",
          }}
        >
          <Line options={options} data={data} />
        </div>
      )}

      {chartPassedData?.chartPassedData?.data?.labels?.length === 0 && (
        <span className="text-center text-bold ws-12 mtl grey">
          No Data Available.
        </span>
      )}
    </>
  );
}